<template>
  <span
      v-if="hasBusinessModels"
      class="stitek stitek--ad"
      @click.stop="$emit('show-business-models', businessModels)"
  >
    AD{{ this.businessModels && this.businessModels.length > 0 ? '!' : '' }}
  </span>
</template>

<script>
export default {
  name: "ChannelAdvertisingProviderChannelGroupLabel",
  props: {
    businessModels: Array,
    hasBusinessModels: Boolean,
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/ChannelAdvertisingProviderChannelGroupLabel.vue